module.exports = __webpack_public_path__ + "media/backgrounds/alex-kulikov-vBpefozS0As-unsplash-f0568ea9.jpg";